var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputepic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18558_13177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.01562 2.18896V0.439453",
    stroke: "#454C58",
    strokeWidth: 0.912265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57812 2.18896V0.439453",
    stroke: "#454C58",
    strokeWidth: 0.912265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.139 9.18701H12.3145",
    stroke: "#454C58",
    strokeWidth: 0.912265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.139 4.81299H12.3145",
    stroke: "#454C58",
    strokeWidth: 0.912265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.27961 9.18701H0.455078",
    stroke: "#454C58",
    strokeWidth: 0.912265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.27961 4.81299H0.455078",
    stroke: "#454C58",
    strokeWidth: 0.912265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01562 13.5605V11.811",
    stroke: "#454C58",
    strokeWidth: 0.912265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57812 13.5605V11.811",
    stroke: "#454C58",
    strokeWidth: 0.912265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3107 2.18896H3.28279C2.72858 2.18896 2.2793 2.61977 2.2793 3.1512V10.849C2.2793 11.3805 2.72858 11.8113 3.28279 11.8113H11.3107C11.8649 11.8113 12.3142 11.3805 12.3142 10.849V3.1512C12.3142 2.61977 11.8649 2.18896 11.3107 2.18896Z",
    stroke: "#454C58",
    strokeWidth: 0.912265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4894 3.93848H4.10352V10.0618H10.4894V3.93848Z",
    stroke: "#6A82D2",
    strokeWidth: 0.912265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18558_13177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.5962,
    height: 13.9961,
    fill: "white",
    transform: "translate(0 0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputepic);
export default __webpack_public_path__ + "static/media/computepic.8b791433b75066bad7bcc2a7ccb93a6b.svg";
export { ForwardRef as ReactComponent };